import { useCallback, useMemo } from "react"

import { Guid } from "@/types"
import  ProfitCenter  from "models/ProfitCenter"
import { ISelectOption } from "components/Select/SelectSearch"
import { $tenantProfitCenters, $userProfitCenterIds, $userProfitCenters } from "stores/profitCenters"
import { useUnit } from "effector-react"
import { ProfitCenters } from "models/ProfitCenters"

export default function useProfitCenters() {
    const userProfitCenters = useUnit($userProfitCenters)
    const userProfitCenterIds = useUnit($userProfitCenterIds)
    const tenantProfitCenters = useUnit($tenantProfitCenters)
    const hasTenantProfitCenters = !!tenantProfitCenters?.items.length

    const keyValueProfitCenters = useMemo<Record<Guid, ProfitCenter>>(() => {
        const _keyValueProfitCenters = tenantProfitCenters?.items.reduce((accum, pC) =>
        ({
            ...accum,
            [pC.id]: pC
        }), {})
        return _keyValueProfitCenters ?? {}
    }, [tenantProfitCenters?.items])

    const getProfitCenterOptions = useCallback((profitCenters: ProfitCenters | null) => {
        return profitCenters?.items.map(pC => ({
            label: pC.description,
            value: pC
        }))
    }, [])

    const getProfitCenterFilterOptions = useCallback((profitCenters: ProfitCenters | null) => {
        return profitCenters?.items.map(pC => ({
            label: pC.description,
            value: pC.id,
            data: pC,
        }))
    }, [])

    const tenantProfitCenterOptions = useMemo<ISelectOption<ProfitCenter>[] | undefined>(() => {
        return getProfitCenterOptions(tenantProfitCenters)
    }, [getProfitCenterOptions, tenantProfitCenters])

    const tenantProfitCenterFilterOptions = useMemo<ISelectOption<Guid, ProfitCenter>[] | undefined>(() => {
        return getProfitCenterFilterOptions(tenantProfitCenters)
    }, [getProfitCenterFilterOptions, tenantProfitCenters])

    const userProfitCenterOptions = useMemo<ISelectOption<ProfitCenter>[] | undefined>(() => {
        return getProfitCenterOptions(userProfitCenters)
    }, [getProfitCenterOptions, userProfitCenters])

    const userProfitCenterFilterOptions = useMemo<ISelectOption<Guid, ProfitCenter>[] | undefined>(() => {
        return getProfitCenterFilterOptions(userProfitCenters)
    }, [getProfitCenterFilterOptions, userProfitCenters])

    return {
        tenantProfitCenters,
        userProfitCenters,
        userProfitCenterIds,
        hasTenantProfitCenters,
        keyValueProfitCenters,
        tenantProfitCenterOptions,
        tenantProfitCenterFilterOptions,
        userProfitCenterOptions,
        userProfitCenterFilterOptions,
    }
}
